function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.19564 2.61328L12.9873 6.40495L9.19564 10.1133V6.85495C6.82897 7.25495 5.02897 9.30495 5.02897 11.7799C5.02897 14.2549 6.82897 16.3049 9.19564 16.7049V18.3883C5.90397 17.9799 3.3623 15.1799 3.3623 11.7799C3.3623 8.37995 5.9123 5.57995 9.19564 5.17161V2.61328ZM15.2872 7.70508C16.0372 8.67174 16.4955 9.78841 16.6372 10.9467H14.9538C14.8372 10.2217 14.5538 9.51341 14.1038 8.88841L15.2872 7.70508ZM10.8623 16.6975V18.3809C12.0206 18.2392 13.1456 17.7892 14.1123 17.0392L12.9123 15.8392C12.2873 16.2892 11.5873 16.5809 10.8623 16.6975ZM15.2872 15.8549L14.1038 14.6799C14.5538 14.0466 14.8372 13.3383 14.9538 12.6133H16.6372C16.4955 13.7716 16.0372 14.8883 15.2872 15.8549Z",
  fill: "current"
});

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.99589114.svg";
export { ForwardRef as ReactComponent };